// user-administration-user-permissions.js
import React, { useState, useEffect } from 'react'
import { Container, Grid } from '@material-ui/core'
import { Checkbox } from '@progress/kendo-react-inputs'
import { ButtonHLPure } from '../../pures'
import { useTranslation } from 'react-i18next'
import LabelPure from '../../pures/label/label.pure'

const UserAdministrationUserPermissions = (props) => {
  const { t, permissions, handleBack, isEditing, setIsEditing, updateUserPermissions } = props
  const { t: tCommon } = useTranslation('common')

  // All needed is to manage the selected IDs during editing
  const [selectedPermissionIds, setSelectedPermissionIds] = useState(
    permissions.filter(p => p.assigned).map(p => p.id)
  )

  // If permissions change (e.g., after saving), reset the local state
  useEffect(() => {
    setSelectedPermissionIds(permissions.filter(p => p.assigned).map(p => p.id))
  }, [permissions])

  const handlePermissionToggle = (permissionId) => {
    if (!isEditing) return
    setSelectedPermissionIds(prev =>
      prev.includes(permissionId)
        ? prev.filter(id => id !== permissionId)
        : [...prev, permissionId]
    )
  }

  const toggleEdit = (value) => {
    if (!value) {
      // Revert to the original state (assigned from the backend)
      setSelectedPermissionIds(permissions.filter(p => p.assigned).map(p => p.id))
    }
    setIsEditing(value)
  }

  const handleSave = async () => {
    try {
      await updateUserPermissions(selectedPermissionIds)
      setIsEditing(false)
    } catch (error) {
      console.error('Error saving permissions:', error)
    }
  }

  // Group by permission type
  const groupedPermissions = permissions.reduce((acc, perm) => {
    const typeName = perm.type?.name || 'Otros'
    if (!acc[typeName]) acc[typeName] = []
    acc[typeName].push(perm)
    return acc
  }, {})

  const hasPermissionsAvailable = Object.keys(groupedPermissions).length > 0 

  return (
    <Container maxWidth='md'>
      {!hasPermissionsAvailable ? (
        <LabelPure title={t('noPermissionsAvailable')} />
      ) : (
        Object.entries(groupedPermissions).map(([typeName, perms]) => (
          <Grid key={typeName} item xs={12} style={{ marginBottom: '24px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {perms.map(perm => (
                <Checkbox
                  key={perm.id}
                  label={perm.name}
                  checked={selectedPermissionIds.includes(perm.id)}
                  onChange={() => handlePermissionToggle(perm.id)}
                  disabled={!isEditing}
                />
              ))}
            </div>
          </Grid>
        ))
      )}

      <div className='button-actions'>
        {hasPermissionsAvailable ? (
          isEditing ? (
            <>
              <ButtonHLPure
                colorScheme='error'
                outlined
                onClick={() => toggleEdit(false)}
                nameBtn={tCommon('cancel')}
              />
              <ButtonHLPure
                primary
                onClick={handleSave}
                nameBtn={tCommon('save')}
              />
            </>
          ) : (
            <>
              <ButtonHLPure
                primary
                outlined
                onClick={handleBack}
                nameBtn={tCommon('goBack')}
              />
              <ButtonHLPure
                primary
                onClick={() => toggleEdit(true)}
                nameBtn={tCommon('edit')}
              />
            </>
          )
        ) : (
          <ButtonHLPure
            primary
            outlined
            onClick={handleBack}
            nameBtn={tCommon('goBack')}
          />
        )}
      </div>
    </Container>
  )
}

export default UserAdministrationUserPermissions